'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearSelectedThread = undefined;

var _reduxActions = require('redux-actions');

var _selectedThreadActionTypes = require('../constants/selectedThreadActionTypes');

var clearSelectedThread = exports.clearSelectedThread = (0, _reduxActions.createAction)(_selectedThreadActionTypes.CLEAR_SELECTED_THREAD);